/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MapLayerConfig } from '../models/MapLayerConfig';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MapLayerControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns MapLayerConfig OK
     * @throws ApiError
     */
    public getMapLayers(): CancelablePromise<Array<MapLayerConfig>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/map-layers',
        });
    }
}
